module.exports = __webpack_public_path__ + "static/media/suicidality.65f929d7.svg";